import './Overview.css'

function Overview() {
    return (
        <>
            <div className="container">
                <h1>Overview</h1>
                <p>I am a passionate Front-End Developer eager to begin my professional journey. I have hands-on experience with HTML, CSS, Tailwind CSS, JavaScript, and React, which I use to create clean, responsive, and visually engaging user interfaces. I enjoy transforming ideas into smooth and user-friendly web experiences. <br />
                    I am enthusiastic about joining a collaborative environment where I can contribute, learn, and grow as a developer while continuously sharpening my skills and staying updated with modern front-end practices.</p>
            </div>
        </>
    )
}

export default Overview;